import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { TSFuntionService } from '../../services/ts-funtion.service';
import { FormBuilder, FormGroup, Validators, FormArray, FormControl } from '@angular/forms';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Resolver } from 'dns';
import { async } from '@angular/core/testing';
import { promise } from 'protractor';
import { SWAlertService } from '../../services/swalert.service';
import Swal from 'sweetalert2';
import { TypeaheadMatch } from 'ngx-bootstrap/typeahead/typeahead-match.class';
import { Router } from '@angular/router';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';

@Component({
  selector: 'app-detail-verify',
  templateUrl: './detail-verify.component.html',
  styleUrls: ['./detail-verify.component.css']
})
export class DetailVerifyComponent implements OnInit {

  modalRef: BsModalRef;
  constructor(
    private System: TSFuntionService,
    private formBuilder: FormBuilder,
    private http: HttpClient,
    private swal: SWAlertService,
    private router: Router,
    private modalService: BsModalService
  ) {
    Window["EVT_AdminAdjust"] = this;
  }
  ua = this.System.GetUserStorage();
  InputFrom: FormGroup;//สร้างกลุ่ม Object Data
  get _InputFrom() { return this.InputFrom.controls; }//ประกาศเพื่อใช้เรียกไปยัง From หน้าบ้าน
  get ListInvoice() { return this._InputFrom.ListInvoice as FormArray; }//Dynamic
  get ListGL() { return this._InputFrom.ListGL as FormArray; }//Dynamic

  PRMS = true;
  PRMS_GRID = true;
  IsEditTaxBase = false;
  sHTMLFlow = "";
  sRequestCode = "";
  ArrBank = [];
  sRequestID = "";
  TR_NoData = true;


  ArrPstKey = [];
  //ArrMaxLineNo = [];
  ArrVatPstKey = [];
  ArrVatType = [];
  ArrWHTType = [];
  ArrWHTCode = [];
  ArrCurrency = [];
  ArrBusinessArea = [];
  ArrBusinessPlace = [];
  ArrPAYMENT_METHOD = [];
  ArrVendorGL = [];
  ArrVendorCosCentor = [];
  ArrVendorIO = [];

  ArrCountry = [];
  ArrProvince = [];
  ArrAmphur = [];
  ArrTumbon = [];

  IsNotFill_IO = false;
  NoInputGL = false;

  Todate = new Date();
  IsReqUrgent = false;
  IsSSCUrgent = false;
  IsOtherReq = false;
  sModalDetail: string = "";
  IsAdvanceReturnFull = false;

  EditInx = null;




  async ngOnInit() {
    this.System.BlockUI();
    this.InputFrom = this.formBuilder.group({
      sRequestCode: null,
      nReqType: null,
      sCompCode: null,
      sDocHeader: [null, Validators.required],
      dDueDate: [new Date(), Validators.required],
      dPostingDate: [new Date(), Validators.required],
      dTranslationDate: [new Date(), Validators.required],
      sBusinessArea: ["", Validators.required],
      sBusinessPlace: ["", Validators.required],
      sPaymentType: 1,
      sBankOther: null,
      sBankName: ["", Validators.required],
      sAccountNo: ["", Validators.required],
      sPaymentMethodName: null,
      sPaymentMethod: null,
      sComment: null,
      sVendorAddress: ["", Validators.required],
      sCountryID: null,
      sCountryName: ["", Validators.required],
      sProvCode: null,
      sProvName: ["", Validators.required],
      sAmpCode: null,
      sAmpName: ["", Validators.required],
      sTumbonCode: null,
      sTumbonName: ["", Validators.required],
      sPostCode: ["", Validators.required],
      ListInvoice: new FormArray([
        new FormGroup({
          sRequestID: new FormControl(null),
          nInvoiceType: new FormControl(null),
          nItemNo: new FormControl(null),
          sInvoiceNo: new FormControl(null, Validators.required),
          dInvoiceDate: new FormControl(null, Validators.required),
          sVendorCode: new FormControl(null),
          sVendorName: new FormControl(null, Validators.required),
          sVendorAddress: new FormControl(null),
          sInvoiceDesc: new FormControl(null, Validators.required),
          nExcludeVAT: new FormControl(null),
          sCurrency: new FormControl(null),
          sVATType: new FormControl(null, Validators.required),
          nVATRate: new FormControl(null),
          nVAT: new FormControl(null),
          nIncludeVAT: new FormControl(null),
          sWHTType: new FormControl(null),
          sWHTCode: new FormControl(null),
          nWHTRate: new FormControl(null),
          nWHTVal: new FormControl(null),
          sWHTType2: new FormControl(null),
          sWHTCode2: new FormControl(null),
          nWHTRate2: new FormControl(null),
          nWHTVal2: new FormControl(null),
          sTAXID: new FormControl(null),
          NoData: new FormControl(null),
          IsVAT: new FormControl(null),
          IsVendorOneTime: new FormControl(null),
          sCountryID: new FormControl(null),
          sCountryName: new FormControl(null),
          sProvCode: new FormControl(null),
          sProvName: new FormControl(null),
          sAmpCode: new FormControl(null),
          sAmpName: new FormControl(null),
          sTumbonCode: new FormControl(null),
          sTumbonName: new FormControl(null),
          sPostCode: new FormControl(null),
          ListGL: new FormArray([
            new FormGroup({
              sRequestID: new FormControl(null),
              nItemNo: new FormControl(null),
              nLineNo: new FormControl(null),
              sDescription: new FormControl(null),
              sGL: new FormControl(null, Validators.required),
              sCCTR: new FormControl(null, Validators.required),
              sIO: new FormControl(null, Validators.required),
              nAmtExcldVAT: new FormControl(null, Validators.required),
              nVAT: new FormControl(null, Validators.required),
              nAmtIncldVAT: new FormControl(null),
              sText: new FormControl(null),
              cActive: new FormControl(null),
              IsVAT: new FormControl(false),
              sRef: new FormControl(null),
              cSSC_Create: new FormControl("Y")
            })
          ]),
          ListPstkey: new FormArray([
            new FormGroup({
              nPstKeyID: new FormControl(null),
              sRequestID: new FormControl(null),
              nItemNo: new FormControl(null),
              nLineNo: new FormControl(null),
              sPstKy: new FormControl(null),
              sRefType: new FormControl(null),
              sRefCode: new FormControl(null),
              sPstType: new FormControl(null),
              sDescription: new FormControl(null),
              nAmountInDoc: new FormControl(null),
              sVATType: new FormControl(null),
              nTaxBase: new FormControl(null, Validators.required),
              sText: new FormControl(null),
              IsDelete: new FormControl(false),
              IsTaxBase: new FormControl(false),
              IsText: new FormControl(false),
              sRef: new FormControl(null)
            })
          ]),
          IsOpenPstKey: new FormControl(false)
        }),
      ]),
      IsHeader: true,
      IsColor: true,
      IsOpenPstKey: false
    })
    let ua = this.System.GetUserStorage();
    if (ua) {

    }
    let ID: string = this.System.GetQuerySTR('str');
    this.sRequestID = await this.System.Decrypt(ID);
    let ObjData = {
      sRequestID: this.sRequestID,
      nMenuID: 11
    }
    this.PRMS = await this.System.CheckPermission(ObjData);
    if (this.PRMS) {
      this.PRMS = await this.System.CheckPermissionMeun(11);
    }

    this.SetData();
    this.BindFlow();
    document.getElementById("adjust_tb_Resize").style.width = (document.getElementById("divResize").clientWidth - 5) + "px";
    document.getElementById("divFlowChart").style.width = (document.getElementById("divFlowResize").clientWidth - 5) + "px";
  }

  async SetData() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", this.sRequestID)
    };
    let This = this;
    let res = await this.http.get<any>(this.System.SiteName + "api/AdminAdjust/SetData", httpOptions).toPromise()
    if (res) {
      let _Data = res[0][0];
      this.IsNotFill_IO = res[4][0].IsNotFill_IO;
      let sPaymentType: number = 1;
      switch (_Data.sPaymentType) {
        case "C":
          sPaymentType = 1;
          break;
        case "T":
        default:
          sPaymentType = 2;
          break;
      }

      this.InputFrom.patchValue({
        sCompCode: _Data.sCompCode,
        sBankName: this.System._ParseString(_Data.sBankName),
        sPaymentType: sPaymentType
      });
      await this.SetDataControl();

      let dPostingDate: Date = _Data.dPostingDate != null ? _Data.dPostingDate : new Date();
      let dTranslationDate: Date = _Data.dTranslationDate != null ? _Data.dTranslationDate : new Date();

      let sPaymentMethodName = "";
      let sPaymentMethod = "";
      this.cbPaymentType(sPaymentType, this.System._ParseString(_Data.sBankName), "B");
      if (this.System._ParseString(_Data.sPaymentMethod)) {
        var GetMethod = this.ArrPAYMENT_METHOD.filter(w => w.PAY_METHOD == _Data.sPaymentMethod);
        if (GetMethod) {
          sPaymentMethodName = GetMethod.length > 0 ? GetMethod[0].PAY_METHOD_DESC : "";
          sPaymentMethod = GetMethod.length > 0 ? GetMethod[0].PAY_METHOD : "";
          this.InputFrom.patchValue({
            sPaymentMethodName: sPaymentMethodName,
            sPaymentMethod: sPaymentMethod
          })
        }
      }

      this.InputFrom.patchValue({
        sRequestCode: _Data.sRequestCode,
        nReqType: _Data.nReqType,
        nInvoiceType: _Data.nInvoiceType,
        sDocHeader: _Data.sDocHeader,
        dDueDate: new Date(_Data.dDueDate),
        dPostingDate: new Date(dPostingDate),
        dTranslationDate: new Date(dTranslationDate),
        sBusinessArea: _Data.sBusinessArea,
        sBusinessPlace: this.System._ParseString(_Data.sBusinessPlace) != "" ? _Data.sBusinessPlace : "0000",
        sPaymentType: sPaymentType,
        sBankOther: _Data.sBankOther,
        sBankName: this.System._ParseString(_Data.sBankName),
        sAccountNo: this.System._ParseString(_Data.sAccountNo),
      })

      this.IsReqUrgent = _Data.IsReqUrgent;
      this.IsSSCUrgent = _Data.IsSSCUrgent;

      let _ListInvoice = res[1];
      let _ListGL = res[2];

      //let _ListPstKey = res[3];
      this.ArrPstKey = res[3];
      this.ListInvoice.clear();
      _ListInvoice.forEach(function (Item) {
        This.ListInvoice.push(This.SetFormGroupInArray(Item, _ListGL));
      });


      //this.ArrMaxLineNo = res[5];

      this.PRMS_GRID = this.PRMS;
      switch (_Data.nReqType) {
        case 20://Advance to Employee
          this.NoInputGL = true;
          break;
        case 50:
          this.PRMS_GRID = false;
          this.IsOtherReq = true;
          break;
        case 30:
          if (_Data.nInvoiceType == 3) {
            this.IsAdvanceReturnFull = true;
            this.NoInputGL = true;
          }
          else {
            this.IsEditTaxBase = this.PRMS ? true : false;
            this.NoInputGL = false;
            this.BindTable();
          }
          break;
        default:
          this.IsEditTaxBase = this.PRMS ? true : false;
          this.NoInputGL = false;
          this.BindTable();
          break;
      }
    }

    this.System.UnBlockUI();
  }

  //#region WorkFlow
  ArrFlow = []
  BindFlow() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", this.sRequestID)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/BindFlow", httpOptions).subscribe(res => {
      if (res) {
        this.ArrFlow = res;
        let width: number = this.ArrFlow.length * 240;
        document.getElementById("DIV_FLOW").style.width = width + "px";
      }
    });
  }
  FlowICO(Item) {
    let sColor = "";
    switch (Item.cApprove) {
      case "A":
        sColor = Item.nFlowNo == 1 ? "fas fa-user-edit _flow_icon _text_green_paster" : "fas fa-user-check _flow_icon _text_green_paster";
        break;
      case "R":
        sColor = "fas fa-user-times _flow_icon _text_red_paster";
        break;
      case "W":
        sColor = "fas fa-user-clock _flow_icon _text_orange_paster";
        break;
    }
    return sColor;
  }
  FlowCommentDisplay(_Item, sCase) {
    let Display = false;
    switch (sCase) {
      case "1":
        if (_Item.sComment) {
          Display = (_Item.sComment.length > 15 ? false : true);
        }
        else {
          Display = true;
        }
        break;
      case "2":
        if (_Item.sComment) {
          Display = (_Item.sComment.length < 15 ? false : true);
        }
        break;
    }
    return Display;
  }
  //#endregion

  SetFormGroupInArray(_Item, _ItemGL) {
    let This = this;
    let _sRequestID: string = "";
    let _sItemNo: string = "";
    let _sInvoiceNo: string = "";
    let _dInvoiceDate: Date = null;
    let _sInvoiceDate: string = "";
    let _sVendorCode: string = "";
    let _sVendorName: string = "";
    let _sVendorAddress: string = "";
    let _sInvoiceDesc: string = "";
    let _sExcludeVAT: string = "";
    let _sCurrency: string = "";
    let _sVATType: string = "";
    let _nVATRate: any = null;
    let _sVAT: string = "";
    let _sIncludeVAT: string = "";
    let _sWHTType: string = "";
    let _sWHTCode: string = "";
    let _sWHTRate: string = "";
    let _sWHTVal: string = "";
    let _sWHTType2: string = "";
    let _sWHTCode2: string = "";
    let _sWHTRate2: string = "";
    let _sWHTVal2: string = "";
    let _sTAXID: string = "";
    let _sCountryID: string = "";
    let _sCountryName: string = "";
    let _sProvCode: string = "";
    let _sProvName: string = "";
    let _sAmpCode: string = "";
    let _sAmpName: string = "";
    let _sTumbonCode: string = "";
    let _sTumbonName: string = "";
    let _sPostCode: string = "";

    let _ArrGL = new FormArray([]);
    let _ArrPstkey = new FormArray([]);

    let IsVAT: boolean = true;
    let IsDisabledFormCustom: boolean = false;

    let NoData: boolean = true;
    let IsVendorOneTime: boolean = false;
    if (_Item) {
      _sRequestID = _Item.sRequestID;
      _sItemNo = _Item.nItemNo;
      _sInvoiceNo = _Item.sInvoiceNo;
      _dInvoiceDate = new Date(_Item.dInvoiceDate);
      _sInvoiceDate = this.System._ParseDateToFormat(new Date(_Item.dInvoiceDate), "");
      _sVendorCode = _Item.sVendorCode;
      _sVendorName = _Item.sVendorName;
      _sVendorAddress = _Item.sVendorAddress;
      _sInvoiceDesc = _Item.sInvoiceDesc;
      _sExcludeVAT = this.System._ParseToDecimal(_Item.nExcludeVAT);
      _sCurrency = _Item.sCurrency;
      _sVATType = this.System._ParseString(_Item.sVATType);
      _nVATRate = _Item.nVATRate;
      _sVAT = this.System._ParseToDecimal(_Item.nVAT);
      _sIncludeVAT = this.System._ParseToDecimal(_Item.nIncludeVAT);
      //คณะทำงานแจ้งให้ระบบ Default WHT type เป็น P1 ในกรณีที่พนักงาน RO กรอก WHT code มา
      if (_Item.sWHTType) {
        _sWHTType = _Item.sWHTType;
      }
      else {
        if (_Item.sWHTCode) {
          _sWHTType = "P1";
        }
      }
      _sWHTCode = this.System._ParseString(_Item.sWHTCode);
      _sWHTRate = this.System._ParseToDecimal(_Item.nWHTRate);
      _sWHTVal = this.System._ParseToDecimal(_Item.nWHTVal);
      _sWHTType2 = this.System._ParseString(_Item.sWHTType2);
      _sWHTCode2 = this.System._ParseString(_Item.sWHTCode2);
      _sWHTRate2 = this.System._ParseToDecimal(_Item.nWHTRate2);
      _sWHTVal2 = this.System._ParseToDecimal(_Item.nWHTVal2);
      _sTAXID = _Item.sTAXID;

      _sCountryID = this.System._ParseString(_Item.sCountryID);
      _sCountryName = this.System._ParseString(_Item.sCountryName);
      _sProvCode = this.System._ParseString(_Item.sProvCode);
      _sProvName = this.System._ParseString(_Item.sProvName);
      _sAmpCode = this.System._ParseString(_Item.sAmpCode);
      _sAmpName = this.System._ParseString(_Item.sAmpName);
      _sTumbonCode = this.System._ParseString(_Item.sTumbonCode);
      _sTumbonName = this.System._ParseString(_Item.sTumbonName);
      _sPostCode = this.System._ParseString(_Item.sPostCode);


      let _nInvoiceType = _Item.nInvoiceType;
      let _VatRate = this.System._ParseFloatToZero(_Item.nVATRate);

      //เช็คกรณี Vat เป้น null
      if (this.PRMS_GRID) {
        if (_nVATRate == null || _nVATRate + "" == "") {
          IsVAT = false;
        }
        else {
          IsVAT = true;
        }
      }
      else {
        IsVAT = true;
      }

      let nReqType: number = 0;
      nReqType = this.InputFrom.controls["nReqType"].value;
      switch (nReqType) {
        case 50://Other
          IsDisabledFormCustom = true;
          IsVAT = false;
          break;
        default:
          break;
      }

      //เช็คกรณี No Vat OR WHT
      if (_nInvoiceType == 2) {

      }

      let ArrGL = _ItemGL.filter(f => f.nItemNo == _sItemNo && f.cActive == "Y");
      NoData = ArrGL.length == 0;
      IsVendorOneTime = this.PRMS_GRID ? _Item.IsVendorOneTime : false;
      ArrGL.forEach(function (Item) {
        let _nAmtExcldVAT = This.System._ParseFloatToZero(Item.nAmtExcldVAT);
        let _nVAT = Item.nVAT == null ? (_nAmtExcldVAT * _VatRate) : This.System._ParseFloatToZero(Item.nVAT);
        let _nAmtIncldVAT = Item.nAmtIncldVAT == null ? (_nAmtExcldVAT + _nVAT) : This.System._ParseFloatToZero(Item.nAmtIncldVAT);
        //if (!IsVAT) {
        //  _nVAT = null;
        //}
        _ArrGL.push(new FormGroup({
          sRequestID: new FormControl(Item.sRequestID),
          nItemNo: new FormControl(Item.nItemNo),
          nLineNo: new FormControl(Item.nLineNo),
          sDescription: new FormControl(Item.sDescription),
          sGL: new FormControl(Item.sGL, Validators.required),
          sCCTR: new FormControl(Item.sCCTR, Validators.required),
          sIO: new FormControl({ value: Item.sIO, disabled: This.IsNotFill_IO }, Validators.required),
          nAmtExcldVAT: new FormControl(This.System._ParseToDecimal(_nAmtExcldVAT)),
          nVAT: new FormControl({ value: This.System._ParseToDecimal(_nVAT), disabled: !IsVAT }, Validators.required),
          nAmtIncldVAT: new FormControl(This.System._ParseToDecimal(_nAmtIncldVAT)),
          sText: new FormControl(Item.sText),
          cActive: new FormControl(Item.cActive),
          IsVAT: new FormControl(IsVAT),
          sRef: new FormControl(null),
          cSSC_Create: new FormControl(Item.cSSC_Create)
        }));
      });

    }

    return new FormGroup({
      sRequestID: new FormControl(_sRequestID),
      nItemNo: new FormControl(_sItemNo),
      sInvoiceNo: new FormControl({ value: _sInvoiceNo, disabled: IsDisabledFormCustom }, Validators.required),
      dInvoiceDate: new FormControl({ value: _dInvoiceDate, disabled: IsDisabledFormCustom }, Validators.required),
      sInvoiceDate: new FormControl(_sInvoiceDate),
      sVendorCode: new FormControl(_sVendorCode),
      sVendorName: new FormControl({ value: _sVendorName, disabled: IsDisabledFormCustom }, Validators.required),
      sVendorAddress: new FormControl({ value: _sVendorAddress, disabled: !IsVendorOneTime }, Validators.required),
      sInvoiceDesc: new FormControl({ value: _sInvoiceDesc, disabled: IsDisabledFormCustom }, Validators.required),
      nExcludeVAT: new FormControl({ value: _sExcludeVAT, disabled: IsDisabledFormCustom }, Validators.required),
      sCurrency: new FormControl(_sCurrency),
      sVATType: new FormControl({ value: _sVATType, disabled: IsDisabledFormCustom }, Validators.required),
      nVATRate: new FormControl(_nVATRate),
      nVAT: new FormControl({ value: _sVAT, disabled: !IsVAT }, Validators.required),
      nIncludeVAT: new FormControl(_sIncludeVAT),
      sWHTType: new FormControl({ value: _sWHTType, disabled: IsDisabledFormCustom }),
      sWHTCode: new FormControl({ value: _sWHTCode, disabled: IsDisabledFormCustom }),
      nWHTRate: new FormControl(_sWHTRate),
      nWHTVal: new FormControl({ value: _sWHTVal, disabled: IsDisabledFormCustom }),
      sWHTType2: new FormControl(_sWHTType2),
      sWHTCode2: new FormControl(_sWHTCode2),
      nWHTRate2: new FormControl(_sWHTRate2),
      nWHTVal2: new FormControl(_sWHTVal2),
      sTAXID: new FormControl({ value: _sTAXID, disabled: !IsVendorOneTime }, Validators.required),
      NoData: new FormControl(NoData),
      IsVAT: new FormControl(IsVAT),
      IsVendorOneTime: new FormControl(IsVendorOneTime),
      sCountryID: new FormControl(_sCountryID),
      sCountryName: new FormControl(_sCountryName),
      sProvCode: new FormControl(_sProvCode),
      sProvName: new FormControl(_sProvName),
      sAmpCode: new FormControl(_sAmpCode),
      sAmpName: new FormControl(_sAmpName),
      sTumbonCode: new FormControl(_sTumbonCode),
      sTumbonName: new FormControl(_sTumbonName),
      sPostCode: new FormControl(_sPostCode),
      ListGL: _ArrGL,
      ListPstkey: _ArrPstkey,
      IsOpenPstKey: new FormControl(false),
    })
  }

  GenFlow() {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sRequestID", this.sRequestID)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetFlow", httpOptions).toPromise().then(res => {
      if (res) {
        this.sHTMLFlow = res;
      }
      else {

      }
    });
  }

  async SetDataControl() {
    //Bank
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sComCode", this.InputFrom.controls["sCompCode"].value)
        .set("cType", "1")
    };
    let GetBank = await this.http.get<any>(this.System.SiteName + "api/_System/GetBank", httpOptions).toPromise();
    if (GetBank) {
      this.ArrBank = GetBank;
    }

    let WHTType = await this.http.get<any>(this.System.SiteName + "api/AdminAdjust/WHTType", httpOptions).toPromise();
    if (WHTType) {
      this.ArrWHTType = WHTType;
    }

    let WHTCode = await this.http.get<any>(this.System.SiteName + "api/AdminAdjust/WHTCode").toPromise();
    if (WHTCode) {
      this.ArrWHTCode = WHTCode;
    }
    //GL
    const httpOptions_GL = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
    };
    let GL = await this.http.get<any>(this.System.SiteName + "api/_System/GetGL", httpOptions_GL).toPromise();
    if (GL) {
      this.ArrVendorGL = GL;
    }

    let VatPstKey = await this.http.get<any>(this.System.SiteName + "api/_System/GetVatPstKey", httpOptions_GL).toPromise();
    if (VatPstKey) {
      this.ArrVatPstKey = VatPstKey;
    }
    //CostCenter
    const httpOptions_CostCenter = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
    };
    let CostCenter = await this.http.get<any>(this.System.SiteName + "api/_System/GetCostCenter", httpOptions_CostCenter).toPromise();
    if (CostCenter) {
      this.ArrVendorCosCentor = CostCenter;
    }

    const httpOptions_IO = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls['sCompCode'].value)
        .set("sCostCenter", "")
    };
    let IO = await this.http.get<any>(this.System.SiteName + "api/_System/GetIO", httpOptions_IO).toPromise();
    if (IO) {
      this.ArrVendorIO = IO;
    }
    let VatType = await this.http.get<any>(this.System.SiteName + "api/_System/_GetVatType").toPromise();
    if (VatType) {
      this.ArrVatType = VatType;
    }
    let Currency = await this.http.get<any>(this.System.SiteName + "api/_System/GetCurrency").toPromise();
    if (Currency) {
      this.ArrCurrency = Currency;
    }
    const httpOptionsBusinessArea = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls["sCompCode"].value)
    };
    let BusinessArea = await this.http.get<any>(this.System.SiteName + "api/_System/GetBusinessArea", httpOptionsBusinessArea).toPromise();
    if (BusinessArea) {
      this.ArrBusinessArea = BusinessArea;
    }
    let BusinessPlace = await this.http.get<any>(this.System.SiteName + "api/_System/GetBusinessPlace", httpOptionsBusinessArea).toPromise();
    if (BusinessPlace) {
      this.ArrBusinessPlace = BusinessPlace;
    }

    //Country
    let Country = await this.http.get<any>(this.System.SiteName + "api/_System/GetContry").toPromise();
    if (Country) {
      this.ArrCountry = Country;
    }

    await this.GET_PAYMENT_METHOD();
  }

  async GET_PAYMENT_METHOD() {
    const httpOptionsPAYMENT_METHOD = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sCompCode", this.InputFrom.controls["sCompCode"].value)
        .set("sBankName", this.InputFrom.controls["sBankName"].value)
        .set("sPaymentType", this.InputFrom.controls["sPaymentType"].value)
    };
    let PAYMENT_METHOD = await this.http.get<any>(this.System.SiteName + "api/_System/GetPAYMENT_METHOD", httpOptionsPAYMENT_METHOD).toPromise();
    if (PAYMENT_METHOD) {
      this.ArrPAYMENT_METHOD = PAYMENT_METHOD;
    }
  }

  BindTable() {
    this.TR_NoData = this.ListInvoice.length != 0;
  }

  onInVoiceChange(value: Date, _inx) {
    if (value) {
      let FromArray = this.InputFrom.get('ListInvoice') as FormArray;
      FromArray.at(_inx).get("sInvoiceDate").setValue(this.System._ParseDateToFormat(value, ""));
    }
  }

  //#region Dropdown
  onchangebank() {
    if (this.InputFrom.controls["sBankName"].value == "Other, please specify") {
      this.InputFrom.controls["sBankOther"].enable();
      this.InputFrom.controls["sBankOther"].setValue(null);//Set ค่า
      this.InputFrom.controls["sBankOther"].setValidators(Validators.required);//กำหนด Validate
      this.InputFrom.controls["sBankOther"].setErrors(null);//ปรับ Control ให้เป็นปกติ
      this.InputFrom.controls["sBankOther"].updateValueAndValidity();//Update Validate
      //this.InputFrom.controls["sBankOther"].markAsTouched({ onlySelf: true });//Update Validate
    }
    else {
      this.InputFrom.controls["sBankOther"].setValue(null);//Set ค่า
      this.InputFrom.controls["sBankOther"].setErrors(null);//ปรับ Control ให้เป็นปกติ
      this.InputFrom.controls["sBankOther"].clearValidators();
      this.InputFrom.controls["sBankOther"].markAsUntouched({ onlySelf: true });//Update Validate
      this.InputFrom.controls["sBankOther"].disable();
    }

    this.PaymentMethodEvent();
  }
  OnChangeVatItem(_Item, _inx) {
    let sVATType: string = _Item.controls["sVATType"].value;
    let nVat: any[] = this.ArrVatType.filter(w => w.TAX_CODE == sVATType);
    let nVATRate: any = null;
    if (nVat) {
      nVATRate = nVat[0].nVAT;
    }
    _Item.controls["nVATRate"].setValue(nVATRate);

    if (nVATRate) {
      _Item.controls["nVAT"].setErrors(null);//ปรับ Control ให้เป็นปกติ
      _Item.controls["nVAT"].markAsUntouched({ onlySelf: true });
      _Item.controls["nVAT"].enable();
      _Item.controls["ListGL"].controls.forEach(function (_ItemSub) {
        _ItemSub.controls["nVAT"].enable();
        _ItemSub.controls["nVAT"].setValidators(Validators.required);//กำหนด Validate
        _ItemSub.controls["nVAT"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        _ItemSub.controls["nVAT"].updateValueAndValidity();//Update Validate
      });
    }
    else {
      _Item.controls["nVAT"].setErrors(null);//ปรับ Control ให้เป็นปกติ
      _Item.controls["nVAT"].markAsUntouched({ onlySelf: true });
      _Item.controls["nVAT"].disable();
      _Item.controls["ListGL"].controls.forEach(function (_ItemSub) {
        _ItemSub.controls["nVAT"].disable();
        _ItemSub.controls["nVAT"].markAsUntouched({ onlySelf: true });
        _ItemSub.controls["nVAT"].setValue(null);
        _ItemSub.controls["nVAT"].setErrors(null);
        _ItemSub.controls["nVAT"].clearValidators();
      });
    }

    this.CalculateITEM(_Item, _inx);
  }
  async PaymentMethodEvent() {
    this.ArrPAYMENT_METHOD = [];
    await this.GET_PAYMENT_METHOD();

    if (this.ArrPAYMENT_METHOD.length == 1) {
      this.InputFrom.patchValue({
        sPaymentMethodName: this.ArrPAYMENT_METHOD[0].PAY_METHOD_DESC,
        sPaymentMethod: this.ArrPAYMENT_METHOD[0].PAY_METHOD,
      })
    }
    else {
      this.InputFrom.patchValue({
        sPaymentMethodName: "",
        sPaymentMethod: ""
      })
    }
  }
  //#endregion

  //#region Event CheckBox
  cbPaymentType(nType, sBankName, sMode) {
    let sValueBank = sBankName != "" ? sBankName : this.InputFrom.controls["sBankName"].value;
    var GetMethod = this.ArrPAYMENT_METHOD;
    switch (nType) {
      case 1:
        //var GetMethod = this.ArrPAYMENT_METHOD.filter(w => w.PAY_METHOD == 0);
        this.InputFrom.patchValue({
          sBankName: "",
          sBankOther: "",
          sAccountNo: "",
          sPaymentMethodName: GetMethod.length == 1 ? GetMethod[0].PAY_METHOD_DESC : "",
          sPaymentMethod: GetMethod.length == 1 ? GetMethod[0].PAY_METHOD + "" : ""
        });

        this.InputFrom.controls["sBankName"].disable();
        this.InputFrom.controls["sBankOther"].disable();
        this.InputFrom.controls["sAccountNo"].disable();

        this.InputFrom.controls["sBankName"].setValue("");//Set ค่า
        this.InputFrom.controls["sBankName"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["sBankName"].markAsUntouched({ onlySelf: true });//Update Validate
        this.InputFrom.controls["sAccountNo"].setValue(null);//Set ค่า
        this.InputFrom.controls["sAccountNo"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["sAccountNo"].markAsUntouched({ onlySelf: true });//Update Validate
        this.InputFrom.controls["sBankOther"].setValue(null);//Set ค่า
        this.InputFrom.controls["sBankOther"].setErrors(null);//ปรับ Control ให้เป็นปกติ
        this.InputFrom.controls["sBankOther"].clearValidators();
        this.InputFrom.controls["sBankOther"].markAsUntouched({ onlySelf: true });//Update Validate
        break;
      case 2:
        //var GetMethod = this.ArrPAYMENT_METHOD.filter(w => w.PAY_METHOD == 5);
        this.InputFrom.patchValue({
          sPaymentMethodName: GetMethod.length == 1 ? GetMethod[0].PAY_METHOD_DESC : "",
          sPaymentMethod: GetMethod.length == 1 ? GetMethod[0].PAY_METHOD + "" : ""
        });

        if (this.PRMS) {
          this.InputFrom.controls["sBankName"].enable();
          this.InputFrom.controls["sAccountNo"].enable();
        }

        this.InputFrom.controls["sBankOther"].markAsTouched({ onlySelf: true });//Update Validate
        this.InputFrom.controls["sBankOther"].disable();

        if (sValueBank == "Other, please specify") {
          if (this.PRMS) {
            this.InputFrom.controls["sBankOther"].enable();
            this.InputFrom.controls["sBankOther"].setValue(null);//Set ค่า
            this.InputFrom.controls["sBankOther"].setValidators(Validators.required);//กำหนด Validate
            this.InputFrom.controls["sBankOther"].setErrors(null);//ปรับ Control ให้เป็นปกติ
            this.InputFrom.controls["sBankOther"].updateValueAndValidity();//Update Validate
          }
          else {
            this.InputFrom.controls["sBankOther"].setErrors(null);//ปรับ Control ให้เป็นปกติ
            this.InputFrom.controls["sBankOther"].markAsUntouched({ onlySelf: false });//Update Validate
          }

        }
        else {
          this.InputFrom.controls["sBankOther"].setValue(null);//Set ค่า
          this.InputFrom.controls["sBankOther"].setErrors(null);//ปรับ Control ให้เป็นปกติ
          this.InputFrom.controls["sBankOther"].clearValidators();
          this.InputFrom.controls["sBankOther"].markAsUntouched({ onlySelf: true });//Update Validate
        }
        break;
    }

    if (sMode == "F") {//ถ้าเป็นการกดมาจากหน้าบ้านจะทำ Event นี้
      this.PaymentMethodEvent();
    }
  }
  //#endregion

  //#region Event AutoComplete
  OnBlurGCI(event: TypeaheadMatch, _Item_Sub, _inx, _sType) {
    let FromArray = this.InputFrom.get('ArrGL') as FormArray;
    let Pass: boolean = true;
    try {
      switch (_sType) {
        case "G":
          if (!event.item.GL_ACCOUNT_NO) {
            Pass = false;
          }
          break;
        case "C":
          if (!event.item.COST_CENTER) {
            Pass = false;
          }
          break;
        case "I":
          if (!event.item.ORDER_NUMBER) {
            Pass = false;
          }
          break;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {

    }
    else {
      switch (_sType) {
        case "G":
          _Item_Sub.patchValue({ sGL: "" });
          break;
        case "C":
          _Item_Sub.patchValue({ sCCTR: "" });
          break;
        case "I":
          _Item_Sub.patchValue({ sIO: "" });
          break;
      }
    }
  }
  OnSelectGCI(event: TypeaheadMatch, _Item, _inx, _sType) {
    let FromArray = _Item.controls["ListGL"] as FormArray;
    let sGL = FromArray.at(_inx).get("sGL").value;
    let sCostCenter = FromArray.at(_inx).get("sCCTR").value;
    let sIO = (FromArray.at(_inx).get("sIO").value != null) ? FromArray.at(_inx).get("sIO").value : ""; //แก้ไขกรณี company ไม่มี IO
    let _CHK = this.OnChange_CheckDuplicateGCI(sGL, sCostCenter, sIO, FromArray, _inx);
    if (!_CHK.IsPass) {
      switch (_sType) {
        case "G":
          FromArray.at(_inx).patchValue({ sGL: "" });
          break;
        case "C":
          FromArray.at(_inx).patchValue({ sCCTR: "" });
          break;
        case "I":
          FromArray.at(_inx).patchValue({ sIO: "" });
          break;
      }
      this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, _CHK.Msg, function () { Swal.close(); });
    }

    let ListPstkey = _Item.controls["ListPstkey"] as FormArray;
    ListPstkey.clear();
  }
  OnChange_CheckDuplicateGCI(sGL, sCCTR, sIO, FromArray, _inx) {
    let Result = { IsPass: true, Msg: "" };
    //Case 1 เช็คจาก Array Invoice
    for (var i = 0; i < FromArray.length; i++) {
      if (i != _inx) {//ตรวจสอบ Index ว่าต้องไม่เป็น Index กับตัวที่ Select
        let Isdelete = FromArray.value[i].cActive == "N";
        let _sGL = FromArray.value[i].sGL;
        let _sCostCenter = FromArray.value[i].sCCTR;
        let _sIO = FromArray.value[i].sIO;
        if (!Isdelete) {
          if (this.IsNotFill_IO) {//IsNotFill_IO คือระบบไม่ต้องกรอก IO
            if (!this.System._IsNullOrEmpty(sGL) && !this.System._IsNullOrEmpty(sCCTR)) {//เช็คแค่ GL,CostCenter
              if (sGL == _sGL && sCCTR == _sCostCenter) {
                Result.IsPass = false;
                Result.Msg = this.swal.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
          else {
            if (!this.System._IsNullOrEmpty(sGL) && !this.System._IsNullOrEmpty(sCCTR) && !this.System._IsNullOrEmpty(sIO)) {//เช็คแค่ GL,CostCenter
              if (sGL == _sGL && sCCTR == _sCostCenter && sIO == _sIO) { //เช็คแค่ GL,CostCenter , IO
                Result.IsPass = false;
                Result.Msg = this.swal.BoxMsg.Desc_Invoice_GCI;
                return Result;
              }
            }
          }
        }
      }
    }

    return Result;
  }
  //PaymentMethod
  OnSelecPaymentMethod(event: TypeaheadMatch): void {
    let _Form = this.InputFrom;
    _Form.patchValue({
      sPaymentMethod: event.item.PAY_METHOD,
    })

  }
  OnBlurPaymentMethod(event: TypeaheadMatch): void {
    let _Form = this.InputFrom;
    let Pass: boolean = true;
    try {
      if (!event.item.PAY_METHOD) {
        Pass = false;
      }
    }
    catch (ex) {//กรณีที่พังจะ Reset ค่าทิ้ง
      Pass = false;
    }
    if (Pass) {

    }
    else {
      _Form.patchValue({
        sPaymentMethodName: null,
        sApsPaymentMethodprove1: null
      });
    }
  }

  //Country
  OnChangeCountry(event: TypeaheadMatch) {
    let sCountry = event.item.sCountryID;
    if (sCountry == "213") {
      this.GetProvince();

      this.InputFrom.patchValue({
        sCountryID: sCountry,
        sProvCode: null,
        sProvName: null,
        sAmpCode: null,
        sAmpName: null,
        sTumbonCode: null,
        sTumbonName: null,
        sPostCode: null
      });

      this.ArrAmphur = [];
      this.ArrTumbon = [];
    }
    else {
      this.InputFrom.patchValue({
        sCountryID: sCountry,
        sProvCode: null,
        sProvName: null,
        sAmpCode: null,
        sAmpName: null,
        sTumbonCode: null,
        sTumbonName: null,
        sPostCode: null
      });
      this.ArrProvince = [];
      this.ArrAmphur = [];
      this.ArrTumbon = [];
    }
  }
  OnBlurCheckCountry(event: TypeaheadMatch): void {
    let CHK = this.ArrCountry.filter(f => f.sCountryName == this.InputFrom.controls["sCountryName"].value);
    if (CHK.length > 0) {
      this.ArrProvince = [];
      if (CHK[0].sCountryID + "" == "213") {
        this.GetProvince();
      }
      else {
        this.InputFrom.patchValue({
          sCountryID: CHK[0].sCountryID + "",
          sCountryName: CHK[0].sCountryName + "",
          sProvCode: null,
          sProvName: null,
          sAmpCode: null,
          sAmpName: null,
          sTumbonCode: null,
          sTumbonName: null
        });
        this.ArrAmphur = [];
        this.ArrTumbon = [];
      }
    }
    else {
      this.InputFrom.patchValue({
        sCountryID: null,
        sCountryName: null,
        sProvCode: null,
        sProvName: null,
        sAmpCode: null,
        sAmpName: null,
        sTumbonCode: null,
        sTumbonName: null
      });
      this.ArrProvince = [];
      this.ArrAmphur = [];
      this.ArrTumbon = [];
    }
  }
  GetProvince() {
    this.http.get<any>(this.System.SiteName + "api/_System/GetProvCode").subscribe(res => {
      if (res) {
        this.ArrProvince = res;
      }
    })
  }
  OnChangeProvCode(event: TypeaheadMatch, Case) {
    this.InputFrom.patchValue({ sProvCode: event.item.sProvCode, sAmpCode: "", sAmpName: "", sTumbonCode: "", sTumbonName: "" });
    this.GetAmphor();
  }
  GetAmphor() {
    const httpOptions_Amphur = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams().set("sProvCode", this.InputFrom.controls["sProvCode"].value)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetAmphur", httpOptions_Amphur).subscribe(res => {
      if (res) {
        this.ArrAmphur = res;
      }
    });
  }
  OnChangeAmpCode(event: TypeaheadMatch) {
    this.InputFrom.patchValue({ sAmpCode: event.item.sAmpCode, sTumbonCode: "", sTumbonName: "" });
    this.GetTumbon();
  }
  GetTumbon() {
    const httpOptions_Tumbon = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      params: new HttpParams()
        .set("sAmpCode", this.InputFrom.controls["sAmpCode"].value)
    };
    this.http.get<any>(this.System.SiteName + "api/_System/GetTumbon", httpOptions_Tumbon).subscribe(res => {
      if (res) {
        this.ArrTumbon = res;
      }
    });
  }
  OnChangeTumbon(event: TypeaheadMatch) {
    this.InputFrom.patchValue({ sTumbonCode: event.item.sTumbonCode });
  }
  OnBlurCheckTH(event: TypeaheadMatch, Case) {
    let ISTH = this.InputFrom.controls["sCountryID"].value == "213";
    if (ISTH)
      switch (Case) {
        case "sProvName":
          if (!event.item.sProvCode) {
            this.InputFrom.patchValue({ sProvCode2: "", sProvName2: "", sAmpCode2: "", sAmpName2: "", sTumbonCode2: "", sTumbonName2: "" });
          }
          break;
        case "sAmpName":
          if (!event.item.sAmpCode) {
            this.InputFrom.patchValue({ sAmpCode2: "", sAmpName2: "", sTumbonCode2: "", sTumbonName2: "" });
          }
          break;
        case "sTumbonName":
          if (!event.item.sTumbonCode) {
            this.InputFrom.patchValue({ sTumbonCode2: "", sTumbonName2: "" });
          }
          break;
      }
  }
  //#endregion

  //#region Event Tag a
  OpenVendor(template: TemplateRef<any>, Item) {
    this.sModalDetail = Item.controls.sVendorName.value;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  OpenVendorAddress(template: TemplateRef<any>, Item) {
    this.sModalDetail = Item.controls.sVendorAddress.value;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  OpenDescription(template: TemplateRef<any>, Item) {
    this.sModalDetail = Item.controls.sDescription.value;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  OpenComment(template: TemplateRef<any>, Item) {
    this.sModalDetail = Item.sComment;
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  //#endregion

  //#region Event
  SaveDraft(_Item, _inx) {
    let _this = this;
    let IsPass = false;
    IsPass = this.CheckDraftValidate(_inx);
    if (IsPass) {
      this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, this.swal.BoxMsg.Desc_Confirm_Save, function () {
        _this.System.BlockUI();
        let _Data = {
          sRequestID: _this.sRequestID,
          nItemNo: _Item.controls['nItemNo'].value,
          sVendorAddress: _Item.controls['sVendorAddress'].value,
          sCountryID: _Item.controls['sCountryID'].value,
          sProvCode: _Item.controls['sProvCode'].value,
          sProvName: _Item.controls['sProvName'].value,
          sAmpCode: _Item.controls['sAmpCode'].value,
          sAmpName: _Item.controls['sAmpName'].value,
          sTumbonCode: _Item.controls['sTumbonCode'].value,
          sTumbonName: _Item.controls['sTumbonName'].value,
          sPostCode: _Item.controls['sPostCode'].value,
          sInvoiceNo: _Item.controls['sInvoiceNo'].value,
          sInvoiceDate: _Item.controls['sInvoiceDate'].value,
          sInvoiceDesc: _Item.controls['sInvoiceDesc'].value,
          nExcludeVAT: _Item.controls['nExcludeVAT'].value,
          nVAT: _Item.controls['nVAT'].value,
          nIncludeVAT: (_Item.controls['nIncludeVAT'].value),
          sVATType: _Item.controls['sVATType'].value,
          sWHTType: _Item.controls['sWHTType'].value,
          sWHTCode: _Item.controls['sWHTCode'].value,
          nWHTRate: _Item.controls['nWHTRate'].value,
          nWHTVal: _Item.controls['nWHTVal'].value,
          sWHTType2: _Item.controls['sWHTType2'].value,
          sWHTCode2: _Item.controls['sWHTCode2'].value,
          nWHTRate2: _Item.controls['nWHTRate2'].value,
          nWHTVal2: _Item.controls['nWHTVal2'].value,
          sTAXID: _Item.controls['sTAXID'].value,

          ListGL: _Item.controls['ListGL'].value,
          ListPstkey: _Item.controls['ListPstkey'].value

        };
        const options = { headers: { 'Content-Type': 'application/json' } };
        _this.http.post<any>(_this.System.SiteName + "api/AdminAdjust/SaveDraft", JSON.stringify(_Data), options).subscribe(res => {
          _this.System.UnBlockUI();
          if (res.Status == _this.System.SysProcess.SessionExpired) {
            _this.System.SessionExpire();
          }
          else if (res.Status == _this.System.SysProcess.Success) {

            var JSONDATA = JSON.parse(res.Content);
            let GLItem = JSONDATA[0];
            _this.ArrPstKey = JSONDATA[1];

            let ListInvoice = _this.InputFrom.controls["ListInvoice"] as FormArray;
            let FromInvoice = ListInvoice.at(_inx) as FormGroup;
            let ListGL = FromInvoice.controls["ListGL"] as FormArray;
            let ListPstkey = FromInvoice.controls["ListPstkey"] as FormArray;

            let IsVAT = true;
            if (_this.PRMS_GRID) {
              //เช็คกรณี Vat เป้น null
              if (_Item.controls["nVATRate"].value == null || _Item.controls["nVATRate"].value + "" == "") {
                IsVAT = false;
              }
              else {
                IsVAT = true;
              }
            }

            ListGL.clear();
            GLItem.forEach(GL_DATA => {
              ListGL.push(new FormGroup({
                sRequestID: new FormControl(GL_DATA.sRequestID),
                nItemNo: new FormControl(GL_DATA.nItemNo),
                nLineNo: new FormControl(GL_DATA.nLineNo),
                sDescription: new FormControl(GL_DATA.sDescription),
                sGL: new FormControl(GL_DATA.sGL, Validators.required),
                sCCTR: new FormControl(GL_DATA.sCCTR, Validators.required),
                //sIO: new FormControl(GL_DATA.sIO, Validators.required),
                sIO: new FormControl({ value: GL_DATA.sIO, disabled: _this.IsNotFill_IO }, Validators.required),
                nAmtExcldVAT: new FormControl(_this.System._ParseToDecimal(GL_DATA.nAmtExcldVAT), Validators.required),
                nVAT: new FormControl({ value: _this.System._ParseToDecimal(GL_DATA.nVAT), disabled: !IsVAT }, Validators.required),
                nAmtIncldVAT: new FormControl(_this.System._ParseToDecimal(GL_DATA.nAmtIncldVAT)),
                sText: new FormControl(GL_DATA.sText),
                cActive: new FormControl(GL_DATA.cActive),
                IsVAT: new FormControl(IsVAT),
                sRef: new FormControl(null),
                cSSC_Create: new FormControl(GL_DATA.cSSC_Create)
              }));
            })

            ListPstkey.clear();

            _this.swal.SwAlert.Success(_this.swal.BoxMsg.Title_Success, _this.swal.BoxMsg.Desc_SaveComplete, function () {
              _Item.controls['ListPstkey'].clear();
              Swal.close();
            });
          }
          else {
            _this.swal.SwAlert.Error(_this.swal.BoxMsg.Title_Error, res.Msg, function () { Swal.close(); });
          }
        });
      }, function () {
        Swal.close();
      });
    }
    else {
      var elmnt = document.getElementById("trInvoice_" + _inx).querySelectorAll(".has-error");
      if (elmnt.length > 0) {
        elmnt[0].scrollIntoView();
      }
      else {
        var elmnt = document.getElementById("trGL_" + _inx).querySelectorAll(".has-error");
        if (elmnt.length > 0) {
          elmnt[0].scrollIntoView();
        }
      }
    }
  }
  CheckDraftValidate(_inx): boolean {
    let IsValid = true;
    let FromArray = this.InputFrom.get('ListInvoice') as FormArray;
    let FromGroup = FromArray.at(_inx) as FormGroup;

    Object.keys(FromGroup.controls).forEach(field => {
      const control = FromGroup.get(field);
      if (control instanceof FormControl) {
        if (!control.valid && !control.disabled) {
          IsValid = false;
          control.markAsTouched({ onlySelf: true });
        }
      }
      else if (control instanceof FormArray) {
        let FromArraySub = control as FormArray;
        for (var i = 0; i < FromArraySub.length; i++) {
          const FromGroupSub = FromArraySub.at(i) as FormGroup;
          Object.keys(FromGroupSub.controls).forEach(fieldsub => {
            const controlSub = FromGroupSub.get(fieldsub);
            if (controlSub instanceof FormControl) {
              if (!controlSub.valid && !controlSub.disabled) {
                IsValid = false;
                controlSub.markAsTouched({ onlySelf: true });
              }
            }
          });
        }
      }
    });

    return IsValid;
  }
  AddGL(_Item, _inx) {
    let FromArray = this.InputFrom.get('ListInvoice') as FormArray;
    let FromGroup = FromArray.at(_inx) as FormGroup;
    let ListPstkey = FromGroup.controls["ListPstkey"] as FormArray;
    let IsVAT = true;
    let IsValid = true;
    let _this = this;
    Object.keys(FromGroup.controls).forEach(field => {
      const control = FromGroup.get(field);
      if (control instanceof FormArray) {
        let FromArraySub = control as FormArray;
        for (var i = 0; i < FromArraySub.length; i++) {
          const FromGroupSub = FromArraySub.at(i) as FormGroup;
          Object.keys(FromGroupSub.controls).forEach(fieldsub => {
            const controlSub = FromGroupSub.get(fieldsub);
            if (controlSub instanceof FormControl) {
              if (!controlSub.valid && !controlSub.disabled) {
                IsValid = false;
                controlSub.markAsTouched({ onlySelf: true });
              }
            }
          });
        }
      }
    });

    if (IsValid) {
      //เช็คกรณี Vat เป้น null
      if (this.PRMS_GRID) {
        if (_Item.controls["nVATRate"].value == null || _Item.controls["nVATRate"].value + "" == "") {
          IsVAT = false;
        }
        else {
          IsVAT = true;
        }
      }

      let FromGL = FromGroup.get('ListGL') as FormArray;
      FromGL.push(new FormGroup({
        sRequestID: new FormControl(_Item.controls["sRequestID"].value),
        nItemNo: new FormControl(_Item.controls["nItemNo"].value),
        nLineNo: new FormControl(null),
        sDescription: new FormControl(null),
        sGL: new FormControl(null, Validators.required),
        sCCTR: new FormControl(null, Validators.required),
        //sIO: new FormControl(null, Validators.required),
        sIO: new FormControl({ value: null, disabled: _this.IsNotFill_IO }, Validators.required),
        nAmtExcldVAT: new FormControl(null, Validators.required),
        nVAT: new FormControl({ value: null, disabled: !IsVAT }, Validators.required),
        nAmtIncldVAT: new FormControl(null),
        sText: new FormControl(null),
        cActive: new FormControl("Y"),
        IsVAT: new FormControl(IsVAT),
        sRef: new FormControl(null),
        cSSC_Create: new FormControl("Y")
      }));

      FromGroup.get("NoData").setValue(false);
    }
    ListPstkey.clear();
    FromGroup.controls["IsOpenPstKey"].setValue(false)

  }
  DeleteGL(_inx, _inxSub) {
    let _This = this;
    this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Delete, this.swal.BoxMsg.Desc_Confirm_Delete, function () {
      let FromArray = _This.InputFrom.get('ListInvoice') as FormArray;
      let FromGroup = FromArray.at(_inx) as FormGroup;
      let FromGL = FromGroup.get('ListGL') as FormArray;
      let ListPstkey = FromGroup.controls["ListPstkey"] as FormArray;
      ListPstkey.clear();
      FromGL.at(_inxSub).get("cActive").setValue("N");
      let FormGLGroup = FromGL.at(_inxSub) as FormGroup;
      Object.keys(FormGLGroup.controls).forEach(_Field => {
        //FormGLGroup.controls[_Field].setValue("");
        FormGLGroup.controls[_Field].setErrors(null);
        FormGLGroup.controls[_Field].clearValidators();
      })
      //Check NoData
      let NoData = FromGL.value.filter(f => f.cActive == "Y") == 0;
      FromGroup.controls["NoData"].setValue(NoData);
    }, function () {
      Swal.close();
    });

  }
  CalculateITEM(_Item, _inx) {
    let nExcludeVAT: any = this.System._ParseFloatToZero(_Item.controls["nExcludeVAT"].value);
    let nVatRate: any = this.System._ParseFloatToZero(_Item.controls["nVATRate"].value);
    let nVat: any = nExcludeVAT * nVatRate;
    let nTotal: any = nExcludeVAT + nVat;
    if (_Item.controls["nVATRate"].value) {
      _Item.controls["nVAT"].setValue(this.System._ParseToDecimal(nVat));
    }
    else {
      _Item.controls["nVAT"].setValue(null);
    }
    _Item.controls["nIncludeVAT"].setValue(this.System._ParseToDecimal(nTotal));
  }
  CalculateITEMVat(_Item, _inx) {
    let nExcludeVAT: any = this.System._ParseFloatToZero(_Item.controls["nExcludeVAT"].value);
    let nVat: any = this.System._ParseFloatToZero(_Item.controls["nVAT"].value);
    let nTotal: any = nExcludeVAT + nVat;
    _Item.controls["nIncludeVAT"].setValue(this.System._ParseToDecimal(nTotal));
  }
  CalculateITEMLine(_Item, _Item_Sub, _inx) {
    let nExcludeVAT: any = this.System._ParseFloatToZero(_Item_Sub.controls["nAmtExcldVAT"].value);
    let nVatRate: any = this.System._ParseFloatToZero(_Item.controls["nVATRate"].value);
    let nVat: any = nExcludeVAT * nVatRate;
    let nTotal: any = nExcludeVAT + nVat;
    if (_Item.controls["nVATRate"].value) {
      _Item_Sub.controls["nVAT"].setValue(this.System._ParseToDecimal(nVat));
    }
    else {
      _Item_Sub.controls["nVAT"].setValue(null);
    }
    _Item_Sub.controls["nAmtIncldVAT"].setValue(this.System._ParseToDecimal(nTotal));

    let ListPstkey = _Item.controls["ListPstkey"] as FormArray;
    ListPstkey.clear();
  }
  CalculateITEMVatLine(_Item, _Item_Sub, _inx) {
    let nExcludeVAT: any = this.System._ParseFloatToZero(_Item_Sub.controls["nAmtExcldVAT"].value);
    let nVat: any = this.System._ParseFloatToZero(_Item_Sub.controls["nVAT"].value);
    let nTotal: any = nExcludeVAT + nVat;
    _Item_Sub.controls["nAmtIncldVAT"].setValue(this.System._ParseToDecimal(nTotal));

    let ListPstkey = _Item.controls["ListPstkey"] as FormArray;
    ListPstkey.clear();
  }
  SaveData(sMode) {
    let _this = this;
    let _FormGroup = this.InputFrom;
    switch (sMode) {
      case "V":
      case "E":
        let Valid = true;
        let FieldVendor: any[] = [
          { _Field: "sDocHeader", _Validator: Validators.required, _Value: "" },
          { _Field: "dDueDate", _Validator: Validators.required, _Value: "" },
          { _Field: "dPostingDate", _Validator: Validators.required, _Value: "" },
          { _Field: "dTranslationDate", _Validator: null, _Value: 1 },
          { _Field: "sBankName", _Validator: Validators.required, _Value: "" },
          { _Field: "sAccountNo", _Validator: Validators.required, _Value: "" },
          { _Field: "sBusinessPlace", _Validator: Validators.required, _Value: "" },
        ];
        switch (_this.InputFrom.controls['nReqType'].value) {
          case 20:
            FieldVendor.forEach(function (Item) {
              if (!_FormGroup.get(Item._Field).valid && !_FormGroup.get(Item._Field).disabled) {
                Valid = false;
                _FormGroup.get(Item._Field).markAsTouched({ onlySelf: true });
                return false;
              }
            });
            break;
          case 30:
            if (_this.InputFrom.controls['nInvoiceType'].value == 30) {
              FieldVendor.forEach(function (Item) {
                if (!_FormGroup.get(Item._Field).valid && !_FormGroup.get(Item._Field).disabled) {
                  Valid = false;
                  _FormGroup.get(Item._Field).markAsTouched({ onlySelf: true });
                  return false;
                }
              });
            }
            else {
              this.validateAllFormFields(this.InputFrom);
              Valid = this.InputFrom.valid;
            }
            break;
          default:
            this.validateAllFormFields(this.InputFrom);
            Valid = this.InputFrom.valid;
            break;
        }

        if (Valid) {
          this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, this.swal.BoxMsg.Desc_Confirm_Save, function () {
            _this.System.BlockUI();
            let _ListInvoice = _this.InputFrom.getRawValue().ListInvoice;

            let _Data = {
              sMode: sMode,
              sRequestID: _this.sRequestID,
              nReqType: _this.InputFrom.controls['nReqType'].value + "",
              sDocHeader: _this.InputFrom.controls['sDocHeader'].value,
              sPostingDate: _this.System._ParseDateToFormat(_this.InputFrom.controls['dPostingDate'].value, ''),
              sDueDate_SSC: _this.System._ParseDateToFormat(_this.InputFrom.controls['dDueDate'].value, ''),
              sTranslationDate: _this.System._ParseDateToFormat(_this.InputFrom.controls['dTranslationDate'].value, ''),
              sPaymentType: _this.InputFrom.controls['sPaymentType'].value == 1 ? "C" : "T",
              sBankName: _this.InputFrom.controls['sBankName'].value,
              sBankOther: _this.InputFrom.controls['sBankOther'].value,
              sAccountNo: _this.InputFrom.controls['sAccountNo'].value,
              sPaymentMethod: _this.InputFrom.controls['sPaymentMethod'].value + "",
              sBusinessPlace: _this.InputFrom.controls['sBusinessPlace'].value,
              TRequestItems: _ListInvoice,
              sComment: _this.InputFrom.get('sComment').value
            };

            const options = { headers: { 'Content-Type': 'application/json' } };
            _this.http.post<any>(_this.System.SiteName + "api/AdminAdjust/SaveData", JSON.stringify(_Data), options).subscribe(res => {
              _this.System.UnBlockUI();
              if (res.Status == _this.System.SysProcess.SessionExpired) {
                _this.System.SessionExpire();
              }
              else if (res.Status == _this.System.SysProcess.Success) {
                _this.swal.SwAlert.Success(_this.swal.BoxMsg.Title_Success, _this.swal.BoxMsg.Desc_SaveComplete, function () {
                  _this.BindFlow();
                  _this.SetData();
                });
              }
              else {
                _this.swal.SwAlert.Error(_this.swal.BoxMsg.Title_Error, res.Msg, function () { Swal.close(); });
              }
            });
          }, function () {
            Swal.close();
          });
        }
        else {
          var elmnt = document.getElementById("DIV_FormData").querySelectorAll(".has-error");
          if (elmnt.length > 0) {
            elmnt[0].scrollIntoView();
          }
        }
        break;
      case "R":
        if (this.InputFrom.get('sComment').value) {
          this.swal.SwAlert.Confirm(this.swal.BoxMsg.Title_Confirm, this.swal.BoxMsg.Desc_Confirm_Save, function () {
            _this.System.BlockUI();
            let _Data = {
              sMode: sMode,
              sRequestID: _this.sRequestID,
              sComment: _this.InputFrom.get('sComment').value
            };
            const options = { headers: { 'Content-Type': 'application/json' } };
            _this.http.post<any>(_this.System.SiteName + "api/AdminAdjust/RejectData", JSON.stringify(_Data), options).subscribe(res => {
              _this.System.UnBlockUI();
              if (res.Status == _this.System.SysProcess.SessionExpired) {
                _this.System.SessionExpire();
              }
              else if (res.Status == _this.System.SysProcess.Success) {
                _this.swal.SwAlert.Success(_this.swal.BoxMsg.Title_Success, _this.swal.BoxMsg.Desc_SaveComplete, function () {
                  //Swal.close();
                  _this.router.navigate(["/admin-task"]);
                });
              }
              else {
                _this.swal.SwAlert.Error(_this.swal.BoxMsg.Title_Error, res.Msg, function () { Swal.close(); });
              }
            });
          }, function () {
            Swal.close();
          });
        } else {
          this.swal.SwAlert.Error(this.swal.BoxMsg.Title_Error, "Please, specify comment", function () { Swal.close(); });
        }

        break;
    }
  }

  GeneratePstkey(_item, _inx) {//หากแก้ฟังช่นนี้ต้องไปปรับส่วนหลังบ้านด้วยใน Systemfunction.GetPostingKey
    let nReqType = this.InputFrom.controls["nReqType"].value;
    //#region TM_VatPstkey
    let IsGenPstkey: boolean = false;
    let IsGenTaxCodeVendor: boolean = false;
    let IsGenTaxCodeGL: boolean = false;
    //#endregion

    //#region Invoice
    let ListInvoice = this.InputFrom.controls["ListInvoice"] as FormArray;
    let FromInvoice = ListInvoice.at(_inx) as FormGroup;
    let nItemNo = FromInvoice.controls["nItemNo"].value;
    let sVATType = FromInvoice.controls["sVATType"].value;
    let sVendorCode = FromInvoice.controls["sVendorCode"].value;
    let sVendorName = FromInvoice.controls["sVendorName"].value;
    let nExcludeVAT = this.System._ParseToDecimal(FromInvoice.controls["nExcludeVAT"].value);
    let nVAT = this.System._ParseToDecimal(FromInvoice.controls["nVAT"].value);
    let nIncludeVAT = this.System._ParseToDecimal(FromInvoice.controls["nIncludeVAT"].value);
    //#endregion

    //#region CheckVlidate Invoice
    let IsValid = true;
    Object.keys(FromInvoice.controls).forEach(field => {
      const control = FromInvoice.get(field);
      if (control instanceof FormArray) {
        let FromArraySub = control as FormArray;
        for (var i = 0; i < FromArraySub.length; i++) {
          const FromGroupSub = FromArraySub.at(i) as FormGroup;
          Object.keys(FromGroupSub.controls).forEach(fieldsub => {
            const controlSub = FromGroupSub.get(fieldsub);
            if (controlSub instanceof FormControl) {
              if (!controlSub.valid && !controlSub.disabled) {
                IsValid = false;
                controlSub.markAsTouched({ onlySelf: true });
              }
            }
          });
        }
      }
    });
    //#endregion
    if (IsValid) {
      let ListGL = FromInvoice.controls["ListGL"] as FormArray;
      let ListPstkey = FromInvoice.controls["ListPstkey"] as FormArray;

      if (ListPstkey.length == 0) {
        let sRefCode: string = "";
        let _sDescription: string = "";
        let nPstKeyID: number = null;

        let _VATPST = this.ArrVatPstKey.filter(w => w.sVatType == sVATType);
        if (_VATPST.length > 0) {
          IsGenPstkey = _VATPST[0].IsGenPstkey;
          IsGenTaxCodeVendor = _VATPST[0].IsGenTaxCodeVendor;
          IsGenTaxCodeGL = _VATPST[0].IsGenTaxCodeGL;
          sRefCode = _VATPST[0].sGL;
          _sDescription = _VATPST[0].sDescription;
        }

        ListPstkey.clear();
        //let VendorTaxCode = IsGenTaxCodeVendor ? sVATType : "";
        let VendorTaxCode = sVATType;

        let _Pstkey31: any = [];
        let sText31 = "";
        let nLineNo = 0;
        switch (nReqType) {
          case 10:
          case 11:
          case 12:
          case 30:
          case 40:
          case 50:
          case 60:
          case 61:
            //#region Pstkey40
            let ListPstkey40: any = [];
            let ListPstkey31: any = [];
            let sRef = "";

            //#region Pstkey31
            _Pstkey31 = this.ArrPstKey.filter(w => w.sRequestID == this.sRequestID && w.nItemNo == nItemNo && w.sPstKy == "31" && w.sRefType == "V" && w.IsDelete == false);
            if (_Pstkey31.length > 0) {
              nPstKeyID = _Pstkey31[0].nPstKeyID;
              sText31 = _Pstkey31[0].sText;
            }

            ListPstkey31.push(
              new FormGroup({
                nPstKeyID: new FormControl(nPstKeyID),
                sRequestID: new FormControl(this.sRequestID),
                nItemNo: new FormControl(nItemNo),
                nLineNo: new FormControl(null),
                sPstKy: new FormControl("31"),
                sRefType: new FormControl("V"),
                sRefCode: new FormControl(sVendorCode),
                sPstType: new FormControl(null),
                sDescription: new FormControl(sVendorName),
                nAmountInDoc: new FormControl(nIncludeVAT),
                sVATType: new FormControl(VendorTaxCode),
                nTaxBase: new FormControl({ value: null, disabled: true }, Validators.required),
                sText: new FormControl({ value: sText31, disabled: true }),
                IsDelete: new FormControl(false),
                IsTaxBase: new FormControl(false),
                IsText: new FormControl(false),
                sRef: new FormControl(sRef)
              })
            )
            //#endregion

            ListGL.controls.forEach(_ITEM => {
              sRef = "";
              nPstKeyID = null;
              let FromGL = _ITEM as FormGroup;
              //let GLTaxCode = IsGenTaxCodeGL ? sVATType : "";
              let GLTaxCode = !IsGenPstkey ? sVATType : "";
              nLineNo = FromGL.controls["nLineNo"].value;
              if (!nLineNo) {
                sRef = new Date().toISOString().slice(0, 19);
                FromGL.controls.sRef.setValue(sRef);
              }
              let sGL = FromGL.controls["sGL"].value;
              let sDescription = FromGL.controls["sDescription"].value;
              let nAmtExcldVAT = this.System._ParseToDecimal(FromGL.controls["nAmtExcldVAT"].value);
              let nVAT = FromGL.controls["nVAT"].value;
              let sText = this.System._IsNullOrEmpty(FromGL.controls["sText"].value) ? sDescription : FromGL.controls["sText"].value;
              let IsDelete = FromGL.controls["cActive"].value == "Y" ? false : true;
              let IsVAT = FromGL.controls["IsVAT"].value;
              if (!IsDelete) {
                if (this.System._IsNullOrEmpty(sDescription)) {
                  let ITEM_GL = this.ArrVendorGL.filter(w => w.GL_ACCOUNT_NO == sGL);
                  if (ITEM_GL.length > 0) {
                    sDescription = ITEM_GL[0].SHORT_TEXT;
                  }
                }
                if (!this.System._IsNullOrEmpty(sGL)) {
                  let _Pstkey40 = this.ArrPstKey.filter(w => w.sRequestID == this.sRequestID && w.nItemNo == nItemNo && w.nLineNo == nLineNo && w.sPstKy == "40" && w.sRefType == "G" && w.IsDelete == false);
                  if (_Pstkey40.length > 0) {
                    nPstKeyID = _Pstkey40[0].nPstKeyID;
                    sText = _Pstkey40[0].sText;
                  }

                  let IsTaxBase: boolean = true;
                  if (!IsVAT) {
                    IsTaxBase = false;
                  }

                  ListPstkey40.push(
                    new FormGroup({
                      nPstKeyID: new FormControl(nPstKeyID),
                      sRequestID: new FormControl(this.sRequestID),
                      nItemNo: new FormControl(nItemNo),
                      nLineNo: new FormControl(nLineNo),
                      sPstKy: new FormControl("40"),
                      sRefType: new FormControl("G"),
                      sRefCode: new FormControl(sGL),
                      sPstType: new FormControl(null),
                      sDescription: new FormControl(sDescription),
                      nAmountInDoc: new FormControl(nAmtExcldVAT),
                      sVATType: new FormControl(GLTaxCode),
                      nTaxBase: new FormControl({ value: this.System._ParseToDecimal(nVAT), disabled: !IsVAT }, Validators.required),
                      sText: new FormControl(sText),
                      IsDelete: new FormControl(IsDelete),
                      IsTaxBase: new FormControl(IsTaxBase),
                      IsText: new FormControl(true),
                      sRef: new FormControl(sRef)
                    })
                  )
                }
              }
            });

            ListPstkey31.forEach(Item => {
              ListPstkey.push(Item);
            });

            ListPstkey40.forEach(Item => {
              ListPstkey.push(Item);
            });

            //#endregion
            //#region Pstkey40 Vat
            if (IsGenPstkey) {
              nPstKeyID = null;
              let sTextVat40: string = "";
              let _Pstkey40 = this.ArrPstKey.filter(w => w.sRequestID == this.sRequestID && w.nItemNo == nItemNo && w.sPstKy == "40" && w.sRefType == "T" && w.IsDelete == false);
              if (_Pstkey40.length > 0) {
                nPstKeyID = _Pstkey40[0].nPstKeyID;
                sTextVat40 = _Pstkey40[0].sText;
              }
              else {
                sTextVat40 = this.InputFrom.controls["sDocHeader"].value;
              }
              ListPstkey.push(
                new FormGroup({
                  nPstKeyID: new FormControl(nPstKeyID),
                  sRequestID: new FormControl(this.sRequestID),
                  nItemNo: new FormControl(nItemNo),
                  nLineNo: new FormControl(null),
                  sPstKy: new FormControl("40"),
                  sRefType: new FormControl("T"),
                  sRefCode: new FormControl(sRefCode),
                  sPstType: new FormControl(null),
                  sDescription: new FormControl(_sDescription),
                  nAmountInDoc: new FormControl(nVAT),
                  sVATType: new FormControl(sVATType),
                  nTaxBase: new FormControl(this.System._ParseToDecimal(nExcludeVAT), Validators.required),
                  sText: new FormControl(sTextVat40),
                  IsDelete: new FormControl(false),
                  IsTaxBase: new FormControl(true),
                  IsText: new FormControl(true),
                  sRef: new FormControl(sRef)
                })
              )
            }
            //#endregion
            break;
        }

        FromInvoice.controls["IsOpenPstKey"].setValue(true);
      }
      else {
        if (FromInvoice.controls["IsOpenPstKey"].value) {
          FromInvoice.controls["IsOpenPstKey"].setValue(false);
        }
        else {
          FromInvoice.controls["IsOpenPstKey"].setValue(true);
        }
      }
    }
  }
  GeneratePstkey_BAK(_item, _inx) {//หากแก้ฟังช่นนี้ต้องไปปรับส่วนหลังบ้านด้วยใน Systemfunction.GetPostingKey Back Up เคสสร้าง Company เท่ากับ GL

    let nReqType = this.InputFrom.controls["nReqType"].value;
    //#region TM_VatPstkey
    let IsGenPstkey: boolean = false;
    let IsGenTaxCodeVendor: boolean = false;
    let IsGenTaxCodeGL: boolean = false;
    //#endregion

    //#region Invoice
    let ListInvoice = this.InputFrom.controls["ListInvoice"] as FormArray;
    let FromInvoice = ListInvoice.at(_inx) as FormGroup;
    let nItemNo = FromInvoice.controls["nItemNo"].value;
    let sVATType = FromInvoice.controls["sVATType"].value;
    let sVendorCode = FromInvoice.controls["sVendorCode"].value;
    let sVendorName = FromInvoice.controls["sVendorName"].value;
    let nExcludeVAT = this.System._ParseToDecimal(FromInvoice.controls["nExcludeVAT"].value);
    let nVAT = this.System._ParseToDecimal(FromInvoice.controls["nVAT"].value);
    let nIncludeVAT = this.System._ParseToDecimal(FromInvoice.controls["nIncludeVAT"].value);
    //#endregion   

    let ListGL = FromInvoice.controls["ListGL"] as FormArray;
    let ListPstkey = FromInvoice.controls["ListPstkey"] as FormArray;

    if (ListPstkey.length == 0) {
      let sRefCode: string = "";
      let _sDescription: string = "";
      let nPstKeyID: number = null;

      let _VATPST = this.ArrVatPstKey.filter(w => w.sVatType == sVATType);
      if (_VATPST.length > 0) {
        IsGenPstkey = _VATPST[0].IsGenPstkey;
        IsGenTaxCodeVendor = _VATPST[0].IsGenTaxCodeVendor;
        IsGenTaxCodeGL = _VATPST[0].IsGenTaxCodeGL;
        sRefCode = _VATPST[0].sGL;
        _sDescription = _VATPST[0].sDescription;
      }

      ListPstkey.clear();
      let VendorTaxCode = IsGenTaxCodeVendor ? sVATType : "";

      let _Pstkey31: any = [];
      let sText31 = "";
      let nLineNo = 0;
      switch (nReqType) {
        case 10:
        case 11:
        case 12:
        case 30:
        case 40:
        case 50:
        case 60:
        case 61:
          //#region Pstkey40
          let ListPstkey40: any = [];
          let ListPstkey31: any = [];
          let sRef = "";
          ListGL.controls.forEach(_ITEM => {
            sRef = "";
            nPstKeyID = null;
            let FromGL = _ITEM as FormGroup;
            let GLTaxCode = IsGenTaxCodeGL ? sVATType : "";
            nLineNo = FromGL.controls["nLineNo"].value;
            if (!nLineNo) {
              sRef = new Date().toISOString().slice(0, 19);
              FromGL.controls.sRef.setValue(sRef);
            }
            let sGL = FromGL.controls["sGL"].value;
            let sDescription = FromGL.controls["sDescription"].value;
            let nAmtExcldVAT = this.System._ParseToDecimal(FromGL.controls["nAmtExcldVAT"].value);
            let nVAT = FromGL.controls["nVAT"].value;
            let sText = this.System._IsNullOrEmpty(FromGL.controls["sText"].value) ? sDescription : FromGL.controls["sText"].value;
            let IsDelete = FromGL.controls["cActive"].value == "Y" ? false : true;
            if (!IsDelete) {
              if (this.System._IsNullOrEmpty(sDescription)) {
                let ITEM_GL = this.ArrVendorGL.filter(w => w.GL_ACCOUNT_NO == sGL);
                if (ITEM_GL.length > 0) {
                  sDescription = ITEM_GL[0].SHORT_TEXT;
                }
              }
              if (!this.System._IsNullOrEmpty(sGL)) {
                let _Pstkey40 = this.ArrPstKey.filter(w => w.sRequestID == this.sRequestID && w.nItemNo == nItemNo && w.nLineNo == nLineNo && w.sPstKy == "40" && w.sRefType == "G" && w.IsDelete == false);
                if (_Pstkey40.length > 0) {
                  nPstKeyID = _Pstkey40[0].nPstKeyID;
                  sText = _Pstkey40[0].sText;
                }
                ListPstkey40.push(
                  new FormGroup({
                    nPstKeyID: new FormControl(nPstKeyID),
                    sRequestID: new FormControl(this.sRequestID),
                    nItemNo: new FormControl(nItemNo),
                    nLineNo: new FormControl(nLineNo),
                    sPstKy: new FormControl("40"),
                    sRefType: new FormControl("G"),
                    sRefCode: new FormControl(sGL),
                    sPstType: new FormControl(null),
                    sDescription: new FormControl(sDescription),
                    nAmountInDoc: new FormControl(nAmtExcldVAT),
                    sVATType: new FormControl(GLTaxCode),
                    nTaxBase: new FormControl(nVAT, Validators.required),
                    sText: new FormControl(sText),
                    IsDelete: new FormControl(IsDelete),
                    sRef: new FormControl(sRef)
                  })
                )

                //#region Pstkey31
                _Pstkey31 = this.ArrPstKey.filter(w => w.sRequestID == this.sRequestID && w.nItemNo == nItemNo && w.sPstKy == "31" && w.sRefType == "V" && w.IsDelete == false);
                if (_Pstkey31.length > 0) {
                  nPstKeyID = _Pstkey31[0].nPstKeyID;
                  sText31 = _Pstkey31[0].sText;
                }

                let nAmountInDoc: any = null;
                if (nAmtExcldVAT || nVAT) {
                  nAmountInDoc = this.System._ParseToDecimal((this.System._ParseFloatToZero(nAmtExcldVAT) + this.System._ParseFloatToZero(nVAT)) + "");
                }

                ListPstkey31.push(
                  new FormGroup({
                    nPstKeyID: new FormControl(nPstKeyID),
                    sRequestID: new FormControl(this.sRequestID),
                    nItemNo: new FormControl(nItemNo),
                    nLineNo: new FormControl(nLineNo),
                    sPstKy: new FormControl("31"),
                    sRefType: new FormControl("V"),
                    sRefCode: new FormControl(sVendorCode),
                    sPstType: new FormControl(null),
                    sDescription: new FormControl(sVendorName),
                    //nAmountInDoc: new FormControl(nIncludeVAT),
                    nAmountInDoc: new FormControl(nAmountInDoc),
                    sVATType: new FormControl(VendorTaxCode),
                    nTaxBase: new FormControl(null, Validators.required),
                    sText: new FormControl(sText31),
                    IsDelete: new FormControl(false),
                    sRef: new FormControl(sRef)
                  })
                )
                //#endregion
              }
            }
          });

          ListPstkey40.forEach(Item => {
            ListPstkey.push(Item);
          });
          ListPstkey31.forEach(Item => {
            ListPstkey.push(Item);
          });
          //#endregion
          //#region Pstkey40 Vat
          if (IsGenPstkey) {
            nPstKeyID = null;
            let sTextVat40: string = "";
            let _Pstkey40 = this.ArrPstKey.filter(w => w.sRequestID == this.sRequestID && w.nItemNo == nItemNo && w.sPstKy == "40" && w.sRefType == "T" && w.IsDelete == false);
            if (_Pstkey40.length > 0) {
              nPstKeyID = _Pstkey40[0].nPstKeyID;
              sTextVat40 = _Pstkey40[0].sText;
            }
            ListPstkey.push(
              new FormGroup({
                nPstKeyID: new FormControl(nPstKeyID),
                sRequestID: new FormControl(this.sRequestID),
                nItemNo: new FormControl(nItemNo),
                nLineNo: new FormControl(nLineNo),
                sPstKy: new FormControl("40"),
                sRefType: new FormControl("T"),
                sRefCode: new FormControl(sRefCode),
                sPstType: new FormControl(null),
                sDescription: new FormControl(_sDescription),
                nAmountInDoc: new FormControl(nVAT),
                sVATType: new FormControl(sVATType),
                nTaxBase: new FormControl(this.System._ParseToDecimal(nExcludeVAT), Validators.required),
                sText: new FormControl(sTextVat40),
                IsDelete: new FormControl(false),
                sRef: new FormControl(sRef)
              })
            )
          }
          //#endregion
          break;
      }
    }
    else {
      ListPstkey.clear();
    }
  }
  UpdateText(_inx, _inxSub) {
    let ListInvoice = this.InputFrom.controls["ListInvoice"] as FormArray;
    let FromInvoice = ListInvoice.at(_inx) as FormGroup;
    let nItemNo = FromInvoice.controls["nItemNo"].value;
    let ListPstkey = FromInvoice.controls["ListPstkey"] as FormArray;
    let This = this;
    ListPstkey.controls.forEach(function (_Item) {
      let FromGroup_PST = _Item as FormGroup;
      let sPstKy: string = FromGroup_PST.controls["sPstKy"].value;
      let sRefType: string = FromGroup_PST.controls["sRefType"].value;
      let nLineNo: number = FromGroup_PST.controls["nLineNo"].value;
      let sText: string = FromGroup_PST.controls["sText"].value;
      let _Pstkey = [];
      switch (sPstKy) {
        case "31":
          _Pstkey = This.ArrPstKey.filter(w => w.sRequestID == This.sRequestID && w.nItemNo == nItemNo && w.sPstKy == sPstKy && w.sRefType == sRefType && w.IsDelete == false);
          break;
        case "40":
          if (sRefType == "G") {
            _Pstkey = This.ArrPstKey.filter(w => w.sRequestID == This.sRequestID && w.nItemNo == nItemNo && w.nLineNo == nLineNo && w.sPstKy == sPstKy && w.sRefType == sRefType && w.IsDelete == false);
          }
          else {
            _Pstkey = This.ArrPstKey.filter(w => w.sRequestID == This.sRequestID && w.nItemNo == nItemNo && w.sPstKy == sPstKy && w.sRefType == sRefType && w.IsDelete == false);
          }
          break;
      }
      if (_Pstkey.length > 0) {
        _Pstkey[0].sText = sText;
      }
    })
  }

  onBack() {
    this.router.navigate(["/admin-task"])
  }
  ExportUniversal() {
    this.System.BlockUI();
    let _this = this;
    let _ListInvoice = _this.InputFrom.controls['ListInvoice'].value;
    let _Data = {
      sMode: "",
      sRequestID: _this.sRequestID,
      nReqType: _this.InputFrom.controls['nReqType'].value + "",
      sDocHeader: _this.InputFrom.controls['sDocHeader'].value,
      sPostingDate: _this.System._ParseDateToFormat(_this.InputFrom.controls['dPostingDate'].value, ''),
      sDueDate_SSC: _this.System._ParseDateToFormat(_this.InputFrom.controls['dDueDate'].value, ''),
      sTranslationDate: _this.System._ParseDateToFormat(_this.InputFrom.controls['dTranslationDate'].value, ''),
      sPaymentType: _this.InputFrom.controls['sPaymentType'].value == 1 ? "C" : "T",
      sBankName: _this.InputFrom.controls['sBankName'].value,
      sBankOther: _this.InputFrom.controls['sBankOther'].value,
      sAccountNo: _this.InputFrom.controls['sAccountNo'].value,
      sPaymentMethod: _this.InputFrom.controls['sPaymentMethod'].value + "",
      sBusinessPlace: _this.InputFrom.controls['sBusinessPlace'].value,
      TRequestItems: _ListInvoice,
      IsHeader: _this.InputFrom.controls['IsHeader'].value,
      IsColor: _this.InputFrom.controls['IsColor'].value,
    };
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    _this.http.post(_this.System.SiteName + "api/ExportUniversal/GenerateUniversalByDataVerify", JSON.stringify(_Data), { headers, responseType: 'arraybuffer' })
      .subscribe(res => {
        var blob = new Blob([res], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
        let fileName = "Universal_" + _this.InputFrom.controls['sRequestCode'].value + ".xlsx"
        if (window.navigator.msSaveOrOpenBlob) { // For IE:
          navigator.msSaveBlob(blob, fileName);
        }
        else {
          const link = document.createElement('a');
          link.target = '_blank'
          var objectUrl = URL.createObjectURL(blob);
          link.href = objectUrl;
          link.setAttribute('download', fileName);
          link.setAttribute('visibility', 'hidden');
          link.click();
        }
        this.System.UnBlockUI();
      });
  }

  OpenAddress(templeteAddress: TemplateRef<any>, _Item, _inx) {
    this.EditInx = _inx;

    let ListInvoice = this.InputFrom.controls["ListInvoice"] as FormArray;
    let FromInvoice = ListInvoice.at(_inx) as FormGroup;

    this.InputFrom.patchValue({
      sVendorAddress: FromInvoice.controls["sVendorAddress"].value,
      sCountryID: FromInvoice.controls["sCountryID"].value,
      sCountryName: FromInvoice.controls["sCountryName"].value,
      sProvCode: FromInvoice.controls["sProvCode"].value,
      sProvName: FromInvoice.controls["sProvName"].value,
      sAmpCode: FromInvoice.controls["sAmpCode"].value,
      sAmpName: FromInvoice.controls["sAmpName"].value,
      sTumbonCode: FromInvoice.controls["sTumbonCode"].value,
      sTumbonName: FromInvoice.controls["sTumbonName"].value,
      sPostCode: FromInvoice.controls["sPostCode"].value
    });

    if (FromInvoice.controls["sCountryID"].value == "213") {
      this.GetProvince();
      this.GetAmphor();
      this.GetTumbon();
    }

    this.modalRef = this.modalService.show(
      templeteAddress,
      Object.assign({}, { class: 'gray modal-xl' })
    );
  }
  UpdateAddress() {
    let Pass = true;
    let Field = ["sVendorAddress", "sCountryName", "sProvName", "sAmpName", "sTumbonName", "sPostCode"];
    let This = this;
    Field.forEach(function (Item) {
      if (!This.InputFrom.get(Item).valid) {
        This.InputFrom.get(Item).markAsTouched({ onlySelf: true });
        Pass = false;
      }
    });

    if (Pass) {
      let ListInvoice = this.InputFrom.controls["ListInvoice"] as FormArray;
      let FromInvoice = ListInvoice.at(this.EditInx) as FormGroup;

      FromInvoice.controls["sVendorAddress"].setValue(this.InputFrom.controls["sVendorAddress"].value);
      FromInvoice.controls["sCountryID"].setValue(this.InputFrom.controls["sCountryID"].value);
      FromInvoice.controls["sCountryName"].setValue(this.InputFrom.controls["sCountryName"].value);
      FromInvoice.controls["sProvCode"].setValue(this.InputFrom.controls["sProvCode"].value);
      FromInvoice.controls["sProvName"].setValue(this.InputFrom.controls["sProvName"].value);
      FromInvoice.controls["sAmpCode"].setValue(this.InputFrom.controls["sAmpCode"].value);
      FromInvoice.controls["sAmpName"].setValue(this.InputFrom.controls["sAmpName"].value);
      FromInvoice.controls["sTumbonCode"].setValue(this.InputFrom.controls["sTumbonCode"].value);
      FromInvoice.controls["sTumbonName"].setValue(this.InputFrom.controls["sTumbonName"].value);
      FromInvoice.controls["sPostCode"].setValue(this.InputFrom.controls["sPostCode"].value);

      this.EditInx = null;
      this.modalRef.hide();
    }
    else {

    }
  }
  //#endregion

  //#region Validate
  isFieldValid(_Field: string) {
    return !this.InputFrom.get(_Field).valid && this.InputFrom.get(_Field).touched;
  }
  displayFieldCss(_Field: string) {
    return {
      'has-error': this.isFieldValid(_Field),
      'has-feedback': this.isFieldValid(_Field)
    };
  }
  isFieldValidInvoice(_Field: string, _inx) {
    let FromArray = this.InputFrom.get('ListInvoice') as FormArray;
    return !FromArray.at(_inx).get(_Field).valid && FromArray.at(_inx).get(_Field).touched;
  }
  displayFieldCssInvoice(_Field: string, _inx) {
    return {
      'has-error': this.isFieldValidInvoice(_Field, _inx),
      'has-feedback': this.isFieldValidInvoice(_Field, _inx)
    };
  }
  isFieldValidGL(_Field: string, _inx, _inxSub) {
    let FromArray = this.InputFrom.get('ListInvoice') as FormArray;
    let FromGroup = FromArray.at(_inx) as FormGroup;
    let FromGL = FromGroup.get('ListGL') as FormArray;

    let Valid = false;
    if (!FromGL.at(_inxSub).get(_Field).disabled) {
      if (!FromGL.at(_inxSub).get(_Field).valid) {// && FromGL.at(_inxSub).get(_Field).touched
        Valid = true;
      }
    }

    return Valid;
  }
  displayFieldCssGL(_Field: string, _inx, _inxSub) {
    return {
      'has-error': this.isFieldValidGL(_Field, _inx, _inxSub),
      'has-feedback': this.isFieldValidGL(_Field, _inx, _inxSub)
    };
  }
  isFieldValidTax(_Field: string, _inx, _inxSub) {
    let FromArray = this.InputFrom.get('ListInvoice') as FormArray;
    let FromGroup = FromArray.at(_inx) as FormGroup;
    let FromGL = FromGroup.get('ListPstkey') as FormArray;
    return !FromGL.at(_inxSub).get(_Field).valid && FromGL.at(_inxSub).get(_Field).touched;
  }
  displayFieldCssTax(_Field: string, _inx, _inxSub) {
    return {
      'has-error': this.isFieldValidTax(_Field, _inx, _inxSub),
      'has-feedback': this.isFieldValidTax(_Field, _inx, _inxSub)
    };
  }


  validateAllFormFields(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach(field => {
      const control = formGroup.get(field);
      if (control instanceof FormControl) {
        if (!control.disabled) { control.markAsTouched({ onlySelf: true }); }
      } else if (control instanceof FormGroup) {
        this.validateAllFormFields(control);
      }
      else if (control instanceof FormArray) {
        for (let i = 0; i < control.length; i++) {
          let FormGroup = control.at(i) as FormGroup;
          this.validateAllFormFields(FormGroup);
        }
      }
    });
  }
  //#endregion

  History(sType: string) {
    switch (sType) {
      case "R":
        window.open("detail-request?str=" + this.System.GetQuerySTR('str'), '_blank');
        break;
      case "V":
        window.open("detail-verify?str=" + this.System.GetQuerySTR('str'), '_blank');
        break;
    }
  }
}
